import { useCallback, memo } from 'react';
import AppsIcon from '@mui/icons-material/Apps';
import ListIcon from '@mui/icons-material/List';
import styles from './style.module.css';

type Layout = 'grid' | 'list';

type FileLayoutSelectorProps = {
  className?: string;
  selected: Layout;
  onSelect: (layout: Layout) => void;
};

export const FileLayoutSelector = memo(({ className, onSelect, selected }: FileLayoutSelectorProps) => {
  const handleClick = useCallback((layout: Layout) => () => {
    onSelect(layout);
  }, [onSelect]);

  return (
    <div className={className}>
      <AppsIcon
        className={selected === 'grid' ? styles.fileLayoutIconActive : styles.fileLayoutIcon}
        onClick={handleClick('grid')}
      />
      <ListIcon
        className={selected === 'list' ? styles.fileLayoutIconActive : styles.fileLayoutIcon}
        onClick={handleClick('list')}
      />
    </div>
  );
});

FileLayoutSelector.displayName = 'FileLayoutSelector';

export default FileLayoutSelector;
